import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api, { formatApiErrorDetail } from '../../lib/adminApi';
import { ImageUpload } from './ImageUpload';

const inputCls = 'w-full border border-[#E6E2DC] px-4 py-2.5 text-sm focus:outline-none focus:border-[#DE92A9] bg-white';
const labelCls = 'block text-xs tracking-wider uppercase text-[#757B7F] mb-1.5';

export default function IssueManager() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/admin/issue')
      .then((res) => setForm({
        title: res.data.title || '',
        description: res.data.description || '',
        image: res.data.image || '',
        video_url: res.data.video_url || '',
        issue_link: res.data.issue_link || '',
      }))
      .catch(() => toast.error('Failed to load latest issue'));
  }, []);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/api/admin/issue', form);
      toast.success('Latest issue updated');
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!form) {
    return <div className="w-8 h-8 border-2 border-[#DE92A9] border-t-transparent rounded-full animate-spin mx-auto mt-12"></div>;
  }

  return (
    <form onSubmit={save} className="bg-white border border-[#E6E2DC]/60 p-8 max-w-3xl space-y-5" data-testid="issue-form">
      <h2 className="text-2xl text-[#2C2C2C]" style={{ fontFamily: '"Playfair Display", serif' }}>Latest Issue</h2>
      <p className="text-xs text-[#757B7F]">This is what appears in the "Latest Issue" section on the homepage.</p>
      <div>
        <label className={labelCls}>Title *</label>
        <input className={inputCls} value={form.title} onChange={set('title')} required data-testid="issue-title-input" />
      </div>
      <div>
        <label className={labelCls}>Description *</label>
        <textarea className={inputCls} rows={4} value={form.description} onChange={set('description')} required data-testid="issue-description-input" />
      </div>
      <div>
        <label className={labelCls}>Read magazine link *</label>
        <input className={inputCls} type="url" value={form.issue_link} onChange={set('issue_link')} required data-testid="issue-link-input" />
      </div>
      <ImageUpload label="Cover image" value={form.image} onChange={(url) => setForm({ ...form, image: url })} testId="issue-cover-upload" />
      <div>
        <label className={labelCls}>Video teaser URL (optional)</label>
        <input className={inputCls} value={form.video_url} onChange={set('video_url')} placeholder="/summer-2026-teaser.mp4" data-testid="issue-video-input" />
      </div>
      <button type="submit" disabled={saving} className="text-white text-xs tracking-[0.15em] font-semibold px-8 py-3 hover:opacity-90 disabled:opacity-50" style={{ backgroundColor: '#DE92A9' }} data-testid="issue-save-btn">
        {saving ? 'SAVING...' : 'SAVE ISSUE'}
      </button>
    </form>
  );
}
